import { UseFormSetValue } from 'react-hook-form'
import { ComboboxItem } from '@node-space/ui-components'
import { stripSpecialCharacters } from 'pages/Contacts/utils/utils'
import { MovePayload } from 'pages/NestedCustomers/types'
import { WalletTransferType } from 'types/unifiedPayouts/unifiedPayouts'

interface UseMoveFormHandlersProps {
  setValue: UseFormSetValue<MovePayload>
  validateAmount: (amount: string) => void
  customerOptions?: ComboboxItem[]
  transferWalletOptions?: ComboboxItem[]
  setSearchQuery: (query: string) => void
}

export const useMoveFormHandlers = ({
  setValue,
  validateAmount,
  customerOptions,
  transferWalletOptions,
  setSearchQuery,
}: UseMoveFormHandlersProps) => {
  const handleWalletTransferTypeSelection = (walletTransferType: WalletTransferType) => {
    setValue('customerReference', '')
    setValue('destinationCustomerName', '')
    setValue('destinationWallet', '')
    setValue('destinationWalletName', '')
    setValue('walletTransferType', walletTransferType)
  }

  const handleCustomerSelection = (customerReference: string) => {
    const selectedCustomer = customerOptions?.find(
      customer => customer?.value === customerReference
    )
    setValue('destinationCustomerName', (selectedCustomer?.leftText as string) || '')
    setValue('customerReference', customerReference)
  }

  const handleDestinationWalletSelection = (walletReference: string) => {
    const selectedWallet = transferWalletOptions?.find(wallet => wallet?.value === walletReference)
    setValue('destinationWalletName', (selectedWallet?.leftText as string) || '')
    setValue('destinationWallet', walletReference)
  }

  const handleSearchQueryChange = (value: string) => {
    setSearchQuery(stripSpecialCharacters(value))
  }

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue('amount', e.target.value)
  }

  const handleAmountBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    validateAmount(e.target.value)
  }

  const handlePaymentReferenceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue('paymentReference', e.target.value)
  }

  return {
    handleWalletTransferTypeSelection,
    handleCustomerSelection,
    handleDestinationWalletSelection,
    handleSearchQueryChange,
    handleAmountChange,
    handleAmountBlur,
    handlePaymentReferenceChange,
  }
}
